<template>
  <main role="Pesanan">
    <div class="row">
      <!-- <div class="col-md-12"> -->
      <div class="card">
        <!-- <div class="card-body"> -->
        <template>
          <PesananTable :transactionRecap="transactionRecap">
            <!-- <pesanan-table source="/api/product" title="Customer Data" /> -->
          </PesananTable>
        </template>
      </div>
    </div>
  </main>
</template>

<script>
import PesananTable from "../Pesanan/PesananTable";
import { mapGetters } from "vuex";

export default {
  components: {
    PesananTable,
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
  methods: {
    transactionRecap() {
      window.open(
        `https://siplah.eurekabookhouse.co.id/api/doc/order-report/${this.user.id}?filter_date=&status=&from=seller`
      );
    },
  },
};
</script>
